import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from "styled-components"
import Container from "./Container"
import Frame from "../images/Frame12.png"

const SurveyResponseSection = () => {
  const data = useStaticQuery(graphql`
    query {
      frame1: file(relativePath: { eq: "Frame12.png" }) {
        childImageSharp {
          fixed(width: 2045, height: 1285, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
    }
  `)

  return (
    <>
      <Img loading="eager" fixed={data.frame1.childImageSharp.fixed} />
    </>
  )
}

export default SurveyResponseSection
